import { useEffect, useState } from 'react';
import { Box, Container } from '@mui/material';
import PageHeader from '../../common/PageHeader';
import { PageDetails } from '../config';
import { useParams } from 'react-router-dom';
import CourseDetailsTabs from './CourseDetailsTabs';

export default function CourseDetails() {
  const id = 'courseDetails';
  const [title, setTitle] = useState('');
  const { termCode, minCrn } = useParams();

  // Retrieves page title from pageDetails using pageid
  useEffect(() => {
    const loadPageTitle = () => {
      const page = PageDetails[id];
      setTitle(page.title);
    };
    loadPageTitle();
  }, []);

  return (
    <div id={`${id}__div_pageWrapper`} className={`myOdu__${id} myOdu__ats`}>
      <Container
        id={`${id}__container_pageWrapper`}
        className="myOdu__container secondaryPage ßfullRightScreenWidth"
      >
        <PageHeader id={id} title={title} subPageId={id} pageConfig={PageDetails} />
        <Box id={`${id}__box_wrapper`} className={'wrapper'}>
          <CourseDetailsTabs id={id} termCode={termCode} crn={minCrn} />
        </Box>
      </Container>
    </div>
  );
}
